import React, { useEffect } from 'react';
import Layout from '../../Layout/Layout';
import Section01 from './Section01/Section01';
import Section02 from './Section02/Section02';
import Section03 from './Section03/Section03';
import Section04 from './Section04/Section04';
import { Helmet } from 'react-helmet-async'; // Import Helmet

const AboutUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <Helmet>
        <title>About Us - RAH Shipping & Logistics</title>
        <meta name="description" content="
RAH Shipping & Logistics is a well-established company specializing in import, export, and customs clearanceRAH Shipping & Logistics is a well-established company specializing in import, export, and customs clearance. We provide services in Pakistan, the Netherlands, and the UAE." />
        
      </Helmet>
      <Section01 />
      <Section02 />
      <Section03 />
      <Section04 />
    </Layout>
  );
};

export default AboutUsPage;